import { createAsyncThunk } from '@reduxjs/toolkit';
import { thunkAxiosRequest } from 'shared/api';
import {
	HallmapResources,
	LayoutItem,
	Resource,
	ResourcesFree,
	ResourcesFreeParams,
	ResourcesState,
	ResourcesStateParams,
	ResourceType,
	UpdateLayoutParams,
} from './types';

export const getHallmapResources = createAsyncThunk<HallmapResources>(
	'/api/v1/resources',
	async (_, { rejectWithValue }) => {
		const resources: Resource[] = await thunkAxiosRequest({
			path: `/api/v1/resources`,
			rejectWithValue,
		});
		const resourceTypes: ResourceType[] = await thunkAxiosRequest({
			path: `/api/v1/resourcetypes`,
			rejectWithValue,
		});
		const layoutItems: LayoutItem[] = await thunkAxiosRequest({
			path: `/api/v1/layoutitems`,
			rejectWithValue,
		});

		return {
			resources,
			resourceTypes,
			layoutItems,
		};
	},
);

export const updateLayoutItem = createAsyncThunk<
	LayoutItem,
	UpdateLayoutParams
>('updateLayoutItem', async (params, { rejectWithValue }) => {
	return await thunkAxiosRequest({
		method: 'patch',
		path: `/api/v1/layoutitems/${params.id}`,
		params,
		rejectWithValue,
	});
});

export const getResourcesState = createAsyncThunk<
	ResourcesState[],
	ResourcesStateParams
>('getResourcesState', async (params, { rejectWithValue }) => {
	return await thunkAxiosRequest({
		method: 'post',
		path: `/api/v1/resources/state`,
		params,
		rejectWithValue,
	});
});

export const getResourcesFree = createAsyncThunk<
	ResourcesFree[],
	ResourcesFreeParams
>('getResourcesFree', async (params, { rejectWithValue }) => {
	return await thunkAxiosRequest({
		method: 'post',
		path: `/api/v1/resources/free`,
		params,
		rejectWithValue,
	});
});

export const getResources = createAsyncThunk<Resource[]>(
	'getResources',
	async (_, { rejectWithValue }) => {
		return await thunkAxiosRequest({
			path: `/api/v1/resources`,
			rejectWithValue,
		});
	},
);
